export const screenTime = [
  { id: 1, name: "Less than 30 minutes" },
  { id: 2, name: "30 minutes - 1 hour" },
  { id: 3, name: "1 - 2 hours" },
  { id: 4, name: "2 - 3 hours" },
  { id: 5, name: "3 - 4 hours" },
  { id: 6, name: "4 - 5 hours" },
  { id: 7, name: "More than 5 hours" },
];
